"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var LogoLink_1 = __importDefault(require("./LogoLink"));
var styles_1 = require("./styles");
var StoreButton_1 = __importDefault(require("./StoreButton"));
var ProfileMenu_1 = __importDefault(require("./ProfileMenu"));
var useLayoutLinks_1 = __importDefault(require("./hooks/useLayoutLinks"));
var TabRow_1 = __importDefault(require("./TabRow"));
var NotificationBell_1 = __importDefault(require("./NotificationBell"));
var SearchExpand_1 = __importDefault(require("./SearchExpand"));
var Layout_1 = __importDefault(require("../context/Layout"));
var SecondaryButtons_1 = __importDefault(require("./SecondaryButtons"));
var VariableHeader = function (_a) {
    var _b, _c, _d;
    var headerView = _a.headerView, multipleBanksObj = _a.multipleBanksObj, logoutUrl = _a.logoutUrl, _e = _a.routerObj, routerPush = _e.routerPush, routerRoutes = _e.routerRoutes, routerPath = _e.routerPath, testRoute = _e.testRoute;
    var _f = __read((0, react_1.useState)(false), 2), searchOpen = _f[0], setSearchOpen = _f[1];
    var _g = __read((0, react_1.useState)(null), 2), profileMenuEl = _g[0], setProfileMenuEl = _g[1];
    var _h = __read((0, react_1.useContext)(Layout_1.default), 2), currentIdentityQuery = _h[0], layoutQuery = _h[1];
    var links = (0, useLayoutLinks_1.default)(layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data);
    var layoutLoading = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.loading;
    var vibeData = (_b = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data) === null || _b === void 0 ? void 0 : _b.vibeGetDerivedVibeDetails;
    var currentIdentityLoading = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.loading;
    var specialPoint = (_d = (_c = vibeData === null || vibeData === void 0 ? void 0 : vibeData.attributes) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.pointsNamePlural;
    var handleNavigation = function (url) { return function (e) {
        if (routerPush && routerRoutes.some(testRoute(url))) {
            e.preventDefault();
            routerPush(url);
        }
        setProfileMenuEl(null);
    }; };
    (0, react_1.useEffect)(function () {
        if (searchOpen) {
            var focusElement = document.getElementById('search-input');
            if (focusElement) {
                focusElement.focus();
            }
        }
    }, [searchOpen]);
    var newTabProps = {
        target: '_blank',
        rel: 'noopener noreferrer',
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.HeaderRow, { slim: !headerView },
            react_1.default.createElement(styles_1.HeaderInnerRow, null,
                react_1.default.createElement(LogoLink_1.default, { handleNavigation: handleNavigation }),
                react_1.default.createElement(styles_1.HeaderCell, null,
                    react_1.default.createElement(SecondaryButtons_1.default, { links: links.secondaryLinks, handleNavigation: handleNavigation, layoutLoading: layoutLoading, newTabProps: newTabProps, headerView: headerView }),
                    react_1.default.createElement(StoreButton_1.default, { multipleBanksObj: __assign(__assign({}, multipleBanksObj), { vibesPointName: specialPoint }), handleNavigation: handleNavigation, vibePointLoading: layoutLoading }),
                    react_1.default.createElement(ProfileMenu_1.default, { links: links.menuLinks, logoutUrl: logoutUrl, handleNavigation: handleNavigation, profileMenuEl: profileMenuEl, setProfileMenuEl: setProfileMenuEl, currentIdentityLoading: currentIdentityLoading })))),
        headerView && (react_1.default.createElement(styles_1.HeaderRow, { secondary: true },
            react_1.default.createElement(styles_1.HeaderInnerRow, null,
                react_1.default.createElement(styles_1.ContainerCell, { searchOpen: searchOpen },
                    react_1.default.createElement(LogoLink_1.default, { handleNavigation: handleNavigation, isCultureCloud: true }),
                    react_1.default.createElement(TabRow_1.default, { handleNavigation: handleNavigation, vibePointLoading: layoutLoading, links: links, newTabProps: newTabProps, routerPath: routerPath })),
                react_1.default.createElement(styles_1.SearchExpandHeaderCell, { searchOpen: searchOpen, snipBorder: false },
                    react_1.default.createElement(SearchExpand_1.default, { searchOpen: searchOpen, handleSearchOpen: setSearchOpen, routerObj: { routerPush: routerPush, routerRoutes: routerRoutes, testRoute: testRoute } })),
                react_1.default.createElement(styles_1.HeaderCell, null,
                    react_1.default.createElement(NotificationBell_1.default, { color: "secondary", "data-testid": "notification-icon" })))))));
};
exports.default = VariableHeader;
//# sourceMappingURL=VariableHeader.js.map